import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why People Read my Weekly Emails",
  "description": "",
  "published": "2017-03-20T00:00:00.000Z",
  "redirect_from": ["/blog/people-read-weekly-emails/swizec/7506"],
  "categories": "Business, Learning, Personal, Side Projects",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Last week, I sent this email to 7,118 people:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/03/why-read-emails-1.png",
        "alt": null
      }}></img></p>
    <p>{`Scary, but necessary. For a while now, I've been feeling my weekly emails aren't as good as they should be. Open rates are dropping, subscribers are churning almost as fast as they're coming in…`}</p>
    <p>{`Not a good place to be. ?`}</p>
    <p>{`I mean, just look at this. 36% open rate on the random question, 22% on the weekly email two days later. Not good at all.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/03/drip-screenshot.png",
        "alt": null
      }}></img></p>
    <p>{`Yes, that `}<em parentName="p">{`does`}</em>{` list only 5,197 subscribers. It's because my email list is split between two Drip accounts. The big list is for people who subscribe by buying a product or signing up for a technical course or getting a free book chapter or something like that. A smaller, 2,000-person list is for those who subscribe directly through this blog.`}</p>
    <p>{`You could say one list leans towards customers and the other leans towards fans. Open and click-through rates are similar for both lists.`}</p>
    <p>{`The lists are split because I thought they were two different types of audiences back when I set it up. They're not.`}</p>
    <h2 {...{
      "id": "heres-what-i-found-out-"
    }}>{`Here's what I found out ?`}</h2>
    <p>{`77 people hated the question and unsubscribed. That hurt, but it's only 1%. I guess I'll live.`}</p>
    <p>{`32 people loved it and shared it on Twitter from the `}<em parentName="p"><a parentName="em" {...{
          "href": "https://swizec.com/thanks.html"
        }}>{`"Thank you for being awesome"`}</a></em>{` page.`}</p>
    <p>{`15 people replied.`}</p>
    <p>{`3 people complained on Twitter that I only gave them one voting option. This was on purpose to force a decision :)`}</p>
    <p>{`500 people clicked a link and voted. That's amazing. Thank you. ❤️`}</p>
    <p>{`Here's the breakdown:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/03/breakdown-screenshot.png",
        "alt": null
      }}></img></p>
    <p>{`My dreams of becoming the Casey Neistat of JavaScript are dashed. ? People don't care about my personal shit. They want code and more code. Some care about the business of code.`}</p>
    <p>{`It's okay. I've heard rumors that the reason people like my code writings is because I make them personal and approachable. ?`}</p>
    <p><strong parentName="p">{`So how am I going to use this info to make my weekly emails better?`}</strong></p>
    <p>{`I'm going to make the emails a lot more personal. I know people said they don't care, but I think that secretly they do. Every week, there's going to be a short cover letter that’s exclusive to the mailing list. This, I think, will improve our relationship.`}</p>
    <p>{`And while all three groups are going to get the same content, it's going to be personalized. For the technical group, the lead story will be technical; for business, the lead will be business; and so on. This, I think, will improve open rates.`}</p>
    <p>{`I'm also going to use this to improve people's onboarding experience. After you subscribe, you'll get to choose a topic.`}</p>
    <p>{`The overall goal is to help people become better engineers. We'll see if it works :)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      